module.exports = __webpack_public_path__ + "img/pi-1-3-3.a97e0f34.jpg";